var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { YearTemplate } from '@/models/YearTemplate';
import { School } from '@/models/School';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue } from 'vue-property-decorator';
import { RolesEnum } from '@/items/Roles';
let YearTemplateDetail = class YearTemplateDetail extends Vue {
    constructor() {
        super(...arguments);
        this.yearTemplate = null;
        this.isLoading = true;
        this.isSaving = false;
        this.isApplying = false;
        this.isSelectingSchools = false;
        this.isLoadingSchools = false;
        this.availableSchools = [];
        this.selectedSchools = [];
        this.savedSnapshot = '';
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        try {
            const result = await new YearTemplate().find(this.$route.params.id);
            this.yearTemplate = result;
            if (!this.yearTemplate.periods) {
                this.yearTemplate.periods = [];
            }
            this.savedSnapshot = this.createSnapshot();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    addPeriod() {
        if (!this.yearTemplate)
            return;
        const order = this.yearTemplate.periods.length + 1;
        this.yearTemplate.periods = [
            ...this.yearTemplate.periods,
            {
                name: `Periode ${order}`,
                period_order: order,
                starts_at: '',
                ends_at: '',
            },
        ];
    }
    removePeriod(index) {
        if (!this.yearTemplate)
            return;
        this.yearTemplate.periods = this.yearTemplate.periods.filter((_, i) => i !== index);
        this.yearTemplate.periods.forEach((p, i) => {
            p.period_order = i + 1;
        });
    }
    async save() {
        if (!this.yearTemplate)
            return;
        this.isSaving = true;
        try {
            this.yearTemplate = await new YearTemplate({ id: this.yearTemplate.id }).put({
                name: this.yearTemplate.name,
                year_name: this.yearTemplate.year_name,
                starts_at: this.yearTemplate.starts_at,
                ends_at: this.yearTemplate.ends_at,
                periods: this.yearTemplate.periods,
            });
            this.savedSnapshot = this.createSnapshot();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isSaving = false;
        }
    }
    async openApplyDialog() {
        this.isSelectingSchools = true;
        this.selectedSchools = [];
        this.isLoadingSchools = true;
        try {
            this.availableSchools = await new School().limit(500).all();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoadingSchools = false;
        }
    }
    async applyToSchools() {
        if (!this.yearTemplate || !this.selectedSchools.length)
            return;
        this.isApplying = true;
        try {
            const schoolIds = this.selectedSchools.map((s) => s.id);
            const result = await new YearTemplate({ id: this.yearTemplate.id }).apply(schoolIds);
            const processed = result.processed || result.data?.processed || 0;
            const total = result.total || result.data?.total || schoolIds.length;
            const errors = result.errors || result.data?.errors || [];
            this.isSelectingSchools = false;
            this.selectedSchools = [];
            this.$store.dispatch('openDialog', {
                title: 'Resultaat',
                text: errors.length
                    ? `${processed} van ${total} scholen verwerkt. ${errors.length} fouten.`
                    : `${processed} van ${total} scholen succesvol verwerkt.`,
                type: errors.length ? 'warning' : 'success',
                buttons: {
                    confirm: { text: 'OK' },
                },
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isApplying = false;
        }
    }
    get hasDateErrors() {
        if (!this.yearTemplate)
            return false;
        if (this.yearTemplate.starts_at && this.yearTemplate.ends_at && this.yearTemplate.ends_at < this.yearTemplate.starts_at) {
            return true;
        }
        return this.yearTemplate.periods.some((p) => p.starts_at && p.ends_at && p.ends_at < p.starts_at);
    }
    get canEdit() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]);
    }
    createSnapshot() {
        if (!this.yearTemplate)
            return '';
        const { name, year_name, starts_at, ends_at, periods } = this.yearTemplate;
        return JSON.stringify({ name, year_name, starts_at, ends_at, periods });
    }
    get hasUnsavedChanges() {
        return this.createSnapshot() !== this.savedSnapshot;
    }
    get breadcrumbs() {
        return [
            { name: 'Instellingen', path: '/admin' },
            { name: 'Schooljaar sjablonen', path: '/admin/year-templates' },
            { name: this.yearTemplate ? this.yearTemplate.name : '' },
        ];
    }
};
YearTemplateDetail = __decorate([
    Component({})
], YearTemplateDetail);
export default YearTemplateDetail;
